import { Optional } from '@/types';
import { GridColDef, GridValidRowModel } from '@mui/x-data-grid';

const commonColsOptions = {
  filterable: false,
  flex: 1,
};

export function getColDef<R extends GridValidRowModel>(
  field: GridColDef<R>['field'],
  headerName: GridColDef<R>['headerName'],
  renderCell: GridColDef<R>['renderCell'],
  other?: Optional<GridColDef<R>, 'field' | 'headerName' | 'renderCell'>,
): GridColDef<R> {
  return {
    ...commonColsOptions,
    renderCell,
    field,
    headerName,
    ...other,
  };
}
